<div class="modal-overlay" (click)="onCancel()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <div class="header-content">
        <div class="modal-icon">
          <mat-icon aria-hidden="true">{{ data.id ? 'edit_note' : 'add_circle_outline' }}</mat-icon>
        </div>
        <h2 class="modal-title">{{ data.id ? 'Modifier le statut' : 'Nouveau statut' }}</h2>
      </div>
      <button class="close-btn" (click)="onCancel()">×</button>
    </div>

    <form [formGroup]="statusForm" (ngSubmit)="onSave()" class="modal-body">
      @if (errorMessage) {
        <div class="alert alert-error mb-4">
          {{ errorMessage }}
        </div>
      }
      <div class="form-group">
        <label for="name">NOM DU STATUT</label>
        <input id="name" type="text" formControlName="name" placeholder="Ex: En attente, Validé..." class="form-control">
        @if (statusForm.get('name')?.invalid && statusForm.get('name')?.touched) {
          <span class="error-text">Le nom est requis</span>
        }
      </div>

      <div class="form-group">
        <label for="metaStatus">MÉTA-STATUT</label>
        <mat-form-field appearance="outline" class="w-full custom-select">
          <mat-select id="metaStatus" formControlName="metaStatus" placeholder="Choisir un méta-statut">
            @for (meta of metaStatuses; track meta) {
              <mat-option [value]="meta">
                <div class="meta-option">
                  <span class="status-dot" [class]="meta.toLowerCase()"></span>
                  {{ meta }}
                </div>
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        @if (statusForm.get('metaStatus')?.invalid && statusForm.get('metaStatus')?.touched) {
          <span class="error-text">Le méta-statut est requis</span>
        }
      </div>

      <div class="form-group">
        <label for="type">TYPE</label>
        <mat-form-field appearance="outline" class="w-full custom-select">
          <mat-select id="type" formControlName="type" placeholder="Choisir un type">
            @for (type of statusTypes; track type) {
              <mat-option [value]="type">{{ type }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div class="form-group">
        <label for="color">COULEUR DU STATUT</label>
        <div class="color-picker-wrapper">
          <input id="color" type="color" formControlName="color" class="color-input">
          <input type="text" [value]="statusForm.get('color')?.value" (input)="statusForm.get('color')?.setValue($any($event.target).value)" class="form-control color-text-input">
        </div>
      </div>

      <div class="modal-footer">
        @if (data.id) {
          <button type="button" class="btn btn-danger-outline" (click)="onRequestDelete()">
            Supprimer / Archiver
          </button>
        }
        <button type="button" class="btn btn-outline" (click)="onCancel()">Annuler</button>
        <button type="submit" class="btn btn-primary" [disabled]="statusForm.invalid">
          {{ data.id ? 'Enregistrer les modifications' : 'Créer le statut' }}
        </button>
      </div>
    </form>
  </div>
</div>

@if (isDeleteConfirmOpen) {
  <app-confirmation-dialog
    [dialogTitle]="getDeleteDialogTitle()"
    [message]="getDeleteDialogMessage()"
    [confirmLabel]="getDeleteDialogLabel()"
    [isDanger]="true"
    (confirm)="confirmDelete()"
    (cancel)="cancelDelete()">
  </app-confirmation-dialog>
}
